// Obtener HOST desde variables de entorno
export const getHost = (): string => {
  // Usar variable de entorno, con fallback a localhost para desarrollo
  return process.env.REACT_APP_API_HOST || 'https://www.qa-tz.cl';
};

const HOST = getHost();
const API_VERSION = 'api/v1';
const build = (p: string) => `${HOST}/${API_VERSION}/${p}`;
export const EndPoints = {
  COMPANIES: {
    LIST: build('companies/'),
    SHOW: build('companies/:id/'),
    STORE: build('companies/store/'),
    UPDATE: build('companies/:id/update/'),
    DELETE: build('companies/:id/delete/'),
  },

  LOCATIONS: {
    LIST: build('locations/'),
    SHOW: build('locations/:id/'),
    STORE: build('locations/store/'),
    UPDATE: build('locations/:id/update/'),
    DELETE: build('locations/:id/delete/'),
  },

  AUTHORIZERS: {
    LIST: build('companies/authorizers/'),
    SHOW: build('companies/authorizers/:id/'),
    CREATE: build('companies/authorizers/create/'),
    STORE: build('companies/authorizers/store/'),
    EDIT: build('companies/authorizers/:id/edit/'),
    UPDATE: build('companies/authorizers/:id/update/'),
    DELETE: build('companies/authorizers/:id/delete/'),
    BY_COMPANY: build('companies/authorizers/by-company/:id/'),

  },

  REQUESTERS: {
    LIST: build('companies/requesters/'),
    SHOW: build('companies/requesters/:id/'),
    CREATE: build('companies/requesters/create/'),
    STORE: build('companies/requesters/store/'),
    EDIT: build('companies/requesters/:id/edit/'),
    UPDATE: build('companies/requesters/:id/update/'),
    DELETE: build('companies/requesters/:id/delete/'),
    BY_COMPANY: build('companies/requesters/by-company/:id/'),
  },

    COST_CENTER: {
    LIST: build('companies/cost-centers/'),
    STORE: build('companies/cost-centers/store/'),
    UPDATE: build('companies/cost-centers/:id/update/'),
    DELETE: build('companies/cost-centers/:id/delete/'),
    EDIT: build('companies/cost-centers/:id/edit/'),
    CREATE: build('companies/cost-centers/create/'),
    BY_COMPANY: build('companies/cost-centers/by-company/:id/'),

  
  },

  PASSES: {
  LIST: build('companies/passes/'),
  SHOW: build('companies/authorizers/:id/'),

  STORE: build('companies/passes/store/'),
  UPDATE: build('companies/passes/:id/update/'),
  DELETE: build('companies/passes/:id/delete/'),
  EDIT: build('companies/passes/:id/edit/'),
  CREATE: build('companies/passes/create/'),
},

  MANAGEMENTS: {
    LIST: build('companies/managements/'),
    STORE: build('companies/managements/store/'),
    EDIT: build('companies/managements/:id/edit/'),
    UPDATE: build('companies/managements/:id/update/'),
    DELETE: build('companies/managements/:id/delete/'),
  },
  SUPERINTENDENCIES: {
    LIST: build('companies/superintendencies/'),
    STORE: build('companies/superintendencies/store/'),
    EDIT: build('companies/superintendencies/:id/edit/'),
    UPDATE: build('companies/superintendencies/:id/update/'),
    DELETE: build('companies/superintendencies/:id/delete/'),
  },
  AREAS: {
    LIST: build('companies/areas/'),
    STORE: build('companies/areas/store/'),
    EDIT: build('companies/areas/:id/edit/'),
    UPDATE: build('companies/areas/:id/update/'),
    DELETE: build('companies/areas/:id/delete/'),
  },
  SERVICE_REASONS: {
    LIST: build('services/service-reasons/'),
    STORE: build('services/service-reasons/store/'),
    EDIT: build('services/service-reasons/:id/edit/'),
    UPDATE: build('services/service-reasons/:id/update/'),
    DELETE: build('services/service-reasons/:id/delete/'),
  },
  EL_ABRA_GROUPS: {
    LIST: build('services/el-abra-groups/'),
    STORE: build('services/el-abra-groups/store/'),
    UPDATE: build('services/el-abra-groups/:id/update/'),
  },

SHIFTS: {
  LIST: build('shifts/'),
  CREATE: build('shifts/create/'),
  STORE: build('shifts/store/'),
  UPDATE: build('shifts/:id/update/'),
  DELETE: build('shifts/:id/delete/'),
},

SHIFT_GROUPS: {
  LIST: build('shifts/groups/'),
  CREATE: build('shifts/groups/create/'),
  STORE: build('shifts/groups/store/'),
  UPDATE: build('shifts/groups/:id/update/'),
  EDIT: build('shifts/groups/:id/edit/'),
  DELETE: build('shifts/groups/:id/delete/'),
},


  DRIVERS: {
    LIST: build('drivers/'),
    EDIT: build('drivers/:id/edit/'),
    CREATE: build('drivers/create/'),
    STORE: build('drivers/store/'),
    UPDATE: build('drivers/:id/update/'),
    DELETE: build('drivers/:id/delete/'),
    BY_COMPANY: build('drivers/by-company/:id/'),
    PASS_EXTENSIONS: build('drivers/:id/pass-extensions/'),
    PASS_HISTORY: build('drivers/:id/pass-history/'),
    RELEASE_VEHICLE: build('drivers/:id/release-vehicle/'),
  },
  VEHICLES: {
    LIST: build('drivers/vehicles/'),
    STORE: build('drivers/vehicles/store/'),
    UPDATE: build('drivers/vehicles/:id/update/'),
    DELETE: build('drivers/vehicles/:id/delete/'),
    EDIT: build('drivers/vehicles/:id/edit/'),
    CREATE: build('drivers/vehicles/create/'),
  },

  PASSENGERS: {
  LIST: build('passengers/'),
  STORE: build('passengers/store/'),
  UPDATE: build('passengers/:id/update/'),
  UPDATE_FROM_SERVICE: build('passengers/:id/update-from-service/'),
  DELETE: build('passengers/:id/delete/'),
  GET_BY_COMPANY: build('passengers/:id/get-by-company/'),
  ADDRESS_LIST: build('passengers/:id/get-by-passenger/'),
  EDIT: build('passengers/:id/edit/'),
  CREATE: build('passengers/create/'),
},
  SERVICES: {
  LIST: build('services/'),
  FILTER_PASSENGERS: build('services/filter/passengers/'),
  SAME_TIME: build('services/same-time/'),
  STORE: build('services/store/'),
  STEP1: build('services/create/step1/'),
  STEP2: build('services/create/step2/:company_id/'),
  STEP3: build('services/create/step3/:company_id/'),
  UPDATE: build('services/:id/update/'),
  UPDATE_ROUTE: build('services/:id/route/'),
  UPDATE_STATUS: build('services/:id/status/'),
  ASSIGN_DRIVER: build('services/:id/assign-driver/'),
  RELEASE_DRIVER: build('services/:id/release-driver/'),
  DUPLICATE: build('services/:id/duplicate/'),
  RETURN: build('services/:id/return/'),
  DELETE: build('services/:id/delete/'),
  EDIT: build('services/edit/:id/'),
  GET_BY_ID: build('/services/:id/'),
  ADICIONAL_UPDATE: build('services/:id/adicional/'),
  CREATE: build('services/create/'),
  HISTORY: build('services/:service_id/history/'),
  PAYMENT_STATUS: build('services/payment-status/'),
  PLANILLA_DOWNLOAD: build('services/planilla/download/'),
  PARSE_EL_ABRA_EXCEL: build('services/parse-el-abra-excel/'),
  IMAGE_TO_EXCEL: build('services/image-to-excel/'),
  BOLETA_GENERATE_FROM_SERVICE: build('services/boletas/generate-from-service'),
  BOLETA_VALIDATE_QR: build('services/boletas/validate-qr'),
  BOLETA_PERSIST: build('services/boletas/:id/persist'),
  VALE_UPLOAD: build('services/vales/upload'),
  NOTES_LIST: build('services/:service_id/notes/'),
  NOTES_STORE: build('services/:service_id/notes/'),
  EMAILS_LIST: build('emails/'),
  EMAILS_DOWNLOAD_SIMPLE: build('emails/download-simple/'),
  EMAILS_KPIS: build('emails/kpis/'),
  EMAILS_DETAIL: build('emails/:id/'),
  EMAILS_SENDER_OPTIONS: build('emails/sender-options/'),
  EMAILS_STORE: build('emails/store/'),
  EMAILS_UPDATE: build('emails/:id/update/'),
  EMAILS_NOTES: build('emails/:id/notes/'),
  EMAILS_MARK_ADDED: build('emails/:id/mark-added/'),
  EMAILS_RECEIVED_AT: build('emails/:id/received-at/'),
  EMAILS_TAGS: build('emails/:id/tags/'),
  EMAILS_COMPANY: build('emails/:id/company/'),
  EMAILS_NOTIFICATIONS: build('emails/notifications/'),
  EMAILS_NOTIFICATIONS_READ: build('emails/notifications/:id/read/'),
  EMAILS_NOTIFICATIONS_READ_ALL: build('emails/notifications/read-all/'),
  EMAILS_ALERTS_UPCOMING_SERVICES: build('emails/alerts/upcoming-services/'),
  EMAILS_SOLICITUDES_ALL: build('emails/solicitudes/'),
  EMAILS_SOLICITUDES_LIST: build('emails/:emailId/solicitudes/'),
  EMAILS_SOLICITUDES_STORE: build('emails/:emailId/solicitudes/store/'),
  EMAILS_SOLICITUDES_UPDATE: build('emails/solicitudes/:id/update/'),
  EMAILS_SOLICITUDES_DELETE: build('emails/solicitudes/:id/delete/'),
  EMAILS_SOLICITUD_SERVICES_STORE: build('emails/solicitudes/:solicitudId/services/store/'),
  EMAILS_SOLICITUD_SERVICE_DELETE: build('emails/solicitud-services/:id/delete/'),
},

  AUTH: {
    LOGIN: build('auth/login/'),
    REFRESH: build('auth/token/refresh/'),
    LOGOUT: build('auth/logout/'),
    PASSWORD_CHANGE: build('auth/password/change/'),
  },


  USER: {
    LIST: build('users/'),
    ME: build('users/me/'),
    CREATE: build('users/create/'),
    STORE: build('users/store/'),
    EDIT: build('users/edit/:id/'),
    UPDATE: build('users/update/:id/'),
    DELETE: build('users/delete/:id/'),
  },
  NOTIFICATION_PREFERENCES: {
    LIST: build('notification-preferences/'),
    UPDATE: build('notification-preferences/:id/'),
  },

};

export default EndPoints;
